import onCloseInlineCompose from './onCloseInlineCompose';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { cleanUpSaveActionManager } from '../actions/trySaveMessage';
import { removeComposeIdFromActedOnMostRecentAttachmentList } from '../orchestrators/onRecipientsInComposeChange';
import { removeComposePlugins } from '../plugins/ComposePlugins';
import { removeViewStateFromBeforeUnloadHandler } from '../utils/beforeUnloadHandler';
import { onCloseDeeplinkCompose } from '../utils/onCloseDeeplinkCompose';
import { getComposeHostItemIndex, lazyOnComposeClose } from 'owa-addins-core';
import { isFeatureEnabled } from 'owa-feature-flags';
import { onCloseFullCompose, onComposeClosed } from 'owa-mail-actions/lib/composeActions';
import { CloseComposeActionName } from 'owa-mail-compose-action-names';
import { ComposeViewState, getStore } from 'owa-mail-compose-store';
import { isDeepLink } from 'owa-popout';
import { isSxSDisplayedWithCompose, lazyCloseComposeInSxS } from 'owa-sxs-store';
import { findTabByData, lazyCloseTab } from 'owa-tab-store';
import { action } from 'satcheljs/lib/legacy';

async function onCloseComposeInReadingPane(viewState: ComposeViewState) {
    if (viewState.isInlineCompose) {
        onCloseInlineCompose(viewState.conversationId);
    }
}

async function closeComposeInSxS(viewState: ComposeViewState) {
    (await lazyCloseComposeInSxS.import())(viewState);
}

export default action(CloseComposeActionName)(function closeCompose(viewState: ComposeViewState) {
    removeViewStateFromBeforeUnloadHandler(viewState);
    removeComposePlugins(viewState);
    cleanUpSaveActionManager(viewState);
    removeInfoBarMessage(viewState);

    const store = getStore();
    const composeId = viewState.composeId;
    const promises: Promise<void>[] = [];

    removeComposeIdFromActedOnMostRecentAttachmentList(composeId);

    if (store.primaryComposeId == composeId) {
        promises.push(onCloseComposeInReadingPane(viewState));
        if (!viewState.isInlineCompose) {
            onCloseFullCompose();
        }

        store.primaryComposeId = null;

        if (isDeepLink()) {
            if (!isFeatureEnabled('rp-popoutsDebug')) {
                onCloseDeeplinkCompose();
            }
        }
    } else {
        const tab = findTabByData(composeId);
        if (tab) {
            promises.push(onCloseComposeInReadingPane(viewState));
            promises.push(lazyCloseTab.importAndExecute(tab, true /*forceClose*/));
        }

        if (isSxSDisplayedWithCompose(viewState)) {
            promises.push(closeComposeInSxS(viewState));
        }
    }

    isFeatureEnabled('rp-addins') &&
        lazyOnComposeClose.import().then(onComposeClose => {
            onComposeClose(getComposeHostItemIndex(viewState.composeId));
        });

    Promise.all(promises).then(() => {
        onComposeClosed();
        store.viewStates.delete(composeId);
    });
});
